import { ColumnItemT } from '@/core/types/tables.types'
import { defineStore } from 'pinia'
import { Ref, ref } from 'vue'

export const useTablesStore = defineStore('tables-store', () => {
    const isOpen = ref(false)
    const columns = ref([]) as Ref<any[]>

    const columnsJSON = localStorage.getItem('columns')
    if (columnsJSON) {
        columns.value = JSON.parse(columnsJSON)
    }

    const toggleModal = () => (isOpen.value = !isOpen.value)

    const getColumns = (path: string, columnsTable: any[]) => {
        const existingColumns = columns.value.find((c) => c.name === path)

        if (!existingColumns) {
            return columnsTable.map((col) => ({ ...col, isChecked: true }))
        }

        const savedColumns: ColumnItemT[] = existingColumns.columns
        const savedIds = savedColumns.map((col) => col.id || col.key) // идентификатор

        const restored = savedColumns.map((col) => {
            const original = columnsTable.find((c) => (c.id || c.key) === (col.id || col.key))
            return {
                ...original,
                isChecked: col.isChecked,
            }
        })

        const newColumns = columnsTable.filter((c) => !savedIds.includes(c.id || c.key))
        const newColumnsChecked = newColumns.map((c) => ({ ...c, isChecked: true }))

        return [...restored, ...newColumnsChecked]
    }

    const setColumns = (path: string, columnsTable: any[]) => {
        const existingColumns = columns.value.find((c) => c.name === path)

        if (existingColumns) {
            const columnsIndex = columns.value.indexOf(existingColumns)
            if (columnsIndex > -1) {
                columns.value[columnsIndex] = { name: path, columns: [...columnsTable] }
            }
        } else {
            columns.value.push({
                name: path,
                columns: [...columnsTable],
            })
        }

        localStorage.setItem('columns', JSON.stringify(columns.value))
        toggleModal()
    }

    return {
        isOpen,
        columns,
        toggleModal,
        getColumns,
        setColumns,
    }
})
